import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Grid, Typography } from '@mui/material';
import Modal, { IModalProps } from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';
import { Form, Formik } from 'formik';
import store from 'store';

import { IResetPasswordData } from '@common/api/auth';
import TextField from '@common/components/Form/TextField';

interface PropsType extends Omit<IModalProps, 'title'> {}

function ResetPasswordModal({ onClose, ...props }: PropsType) {
	const [email, setEmail] = useState(null);
	const [isSubmitted, setIsSubmitted] = useState(null);
	const { t } = useTranslation();

	return (
		<Modal
			PaperProps={{
				sx: {
					maxWidth: '500px',
				},
			}}
			title={t('profile.resetPassword')}
			TransitionComponent={GrowTransition}
			transitionDuration={500}
			onClose={onClose}
			onTransitionExited={() => setIsSubmitted(false)}
			{...props}
		>
			{isSubmitted ? (
				<Typography>{`An email with a link to change your password has been sent to your e-mail ${email}`}</Typography>
			) : (
				<Formik
					onSubmit={async (data, { setErrors }) => {
						try {
							const token = await store.auth.resetPassword(data as IResetPasswordData);
							setEmail(data.email);
							setIsSubmitted(!!token);
						} catch (e) {
							setErrors(e.errors);
							console.error('e', e);
						}
					}}
					initialValues={{
						email: '',
					}}
				>
					<Form>
						<Grid container gap="16px" direction="column">
							<Typography textAlign="center" variant="subtitle2">
								Enter your email to change your password
							</Typography>
							<TextField name="email" placeholder={t('profile.emailPlaceholder')} type="email" />
							<Button
								type="submit"
								variant="contained"
								fullWidth
								sx={{ borderRadius: '10px' }}
								disabled={store.profile.loading}
							>
								{t('shared.send')}
							</Button>
						</Grid>
					</Form>
				</Formik>
			)}
		</Modal>
	);
}

export default observer(ResetPasswordModal);
